import { useState } from 'react';

import { FormFieldSet } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';
import { useFormContext } from 'react-hook-form';

import { useVehiclesListSelectedQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { MultiSelectContextField } from 'src/common/FormField/MultiSelectContextField';
import { CoreFormFieldSwitch } from 'src/common/FormField/v2/core/CoreFormFieldSwitch';

export const PayerAuthorizedVehicleSettings = () => {
  const { watch } = useFormContext();
  const requiresVehicleAuthorization = watch('allow_only_specific_vehicles');
  const allowedVehicles = watch('allowed_vehicles');

  const [query, setQuery] = useState('');

  const {
    data: vehicles,
    isLoading,
    isFetching,
  } = useVehiclesListSelectedQuery({
    search: query,
    vehicleFilters: {
      selected_vehicles: allowedVehicles,
    },
    pageSize: 1000,
  });

  const vehicleOptions = (vehicles?.results ?? []).map((v) => ({
    label: v.nickname || v.id,
    value: v.id,
  }));

  return (
    <div className="py-2">
      <FormFieldSet
        legend="Allowed Vehicles"
        Fields={
          <>
            <FormFieldController name="allow_only_specific_vehicles">
              {({ field }) => {
                return (
                  <CoreFormFieldSwitch
                    colSpan={12}
                    label="Allow only specific vehicles"
                    inputProps={{
                      value: field.value,
                      onChange: field.onChange,
                      id: 'allow_only_specific_vehicles',
                    }}
                    helperText={{
                      text:
                        'Enabling this option means that only vehicles explicitly selected below ' +
                        'will be able to be used for trips with this payer.',
                      presentation: {
                        type: 'tooltip',
                      },
                    }}
                  />
                );
              }}
            </FormFieldController>
            <div className="col-span-12">
              <MultiSelectContextField
                options={vehicleOptions || []}
                fieldPath="allowed_vehicles"
                label="Allowed Vehicles"
                disabled={
                  isLoading || isFetching || !requiresVehicleAuthorization
                }
                searchable
                query={query}
                setQuery={setQuery}
              />
            </div>
          </>
        }
      />
    </div>
  );
};
